import { motion } from "framer-motion";
import { BadgeDollarSign, PhoneCall, Handshake } from "lucide-react";

const promises = [
  {
    icon: BadgeDollarSign,
    title: "Founding-Venue Rates",
    desc: "Launch pricing for our first partner venues, locked in for 12 months as we grow together. Early clients get our best rates — forever remembered.",
  },
  {
    icon: PhoneCall,
    title: "The Founder On Every Job",
    desc: "No account managers, no call centres. You get Joseph's direct line — 0430 941 010 — and the owner personally briefs your crew before doors.",
  },
  {
    icon: Handshake,
    title: "Prove-It Guarantee",
    desc: "If a confirmed post goes unfilled on event day, that shift is on us. We're building our reputation one flawless event at a time — starting with yours.",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="stories" className="py-20 sm:py-28 bg-[#0F111A] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs uppercase tracking-[0.2em] font-mono-tactical font-semibold text-sky-400">
            The Sora Promise
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
            New Agency. Uncompromising Standards.
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">
            We won't show you borrowed logos or recycled testimonials. Here's
            what booking a hungry, founder-led agency actually gets you:
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {promises.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i + 1}`}
              className="group bg-[#131622] border border-white/10 rounded-md p-7 transition-all duration-300 hover:border-sky-500/40 hover:shadow-[0_0_30px_rgba(14,165,233,0.12)] hover:-translate-y-1"
            >
              <span className="w-11 h-11 rounded-sm bg-sky-500/10 border border-sky-500/25 flex items-center justify-center transition-colors duration-300 group-hover:bg-sky-500/20">
                <p.icon className="w-5 h-5 text-sky-500" />
              </span>
              <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-white">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                {p.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
